import { apiSliceType as api } from '../../../api/apiSlice';

export const addTagTypes = ['Coaching'] as const;
const injectedRtkApi = api
    .enhanceEndpoints({
        addTagTypes,
    })
    .injectEndpoints({
        endpoints: (build) => ({
            postCoachingCreateCoachingStrength: build.mutation<
                PostCoachingCreateCoachingStrengthApiResponse,
                PostCoachingCreateCoachingStrengthApiArg
            >({
                query: (queryArg) => ({
                    url: `coaching/create_coaching_strength`,
                    method: 'POST',
                    body: queryArg.createCoachingStrength,
                }),
                invalidatesTags: ['Coaching','coachingInsightHistory'],
            }),
            putCoachingReplyCoachingStrength: build.mutation<
                PutCoachingReplyCoachingStrengthApiResponse,
                PutCoachingReplyCoachingStrengthApiArg
            >({
                query: (queryArg) => ({
                    url: `coaching/reply_coaching_strength`,
                    method: 'PUT',
                    body: queryArg.replyCoachingStrength,
                }),
                invalidatesTags: ['CoachingStrengthModal'],
            }),
            getCoachingCoachingStrength: build.query<
                GetCoachingCoachingStrengthApiResponse,
                GetCoachingCoachingStrengthApiArg
            >({
                query: (queryArg) => ({
                    url: `coaching/coaching_strength`,
                    params: {
                        employeeNumber: queryArg.employeeNumber,
                        authorEmployeeNumber: queryArg.authorEmployeeNumber,
                        month: queryArg.month,
                        year: queryArg.year,
                    },
                }),
                providesTags: ['CoachingStrengthModal', 'Coaching'],
            }),
            putCoachingUpdateCoachingStrength: build.mutation<
                PutCoachingUpdateCoachingStrengthApiResponse,
                PutCoachingUpdateCoachingStrengthApiArg
            >({
                query: (queryArg) => ({
                    url: `coaching/update_coaching_strength`,
                    method: 'PUT',
                    body: queryArg.updateCoachingStrength,
                }),
                invalidatesTags: ['Coaching'],
            }),
        }),
        overrideExisting: false,
    });
export { injectedRtkApi as enhancedApi };
export type PostCoachingCreateCoachingStrengthApiResponse = /** status 200 Success */ BooleanApiResponse;
export type PostCoachingCreateCoachingStrengthApiArg = {
    createCoachingStrength: CreateCoachingStrength[];
};
export type PutCoachingReplyCoachingStrengthApiResponse = /** status 200 Success */ BooleanApiResponse;
export type PutCoachingReplyCoachingStrengthApiArg = {
    replyCoachingStrength: ReplyCoachingStrength;
};
export type GetCoachingCoachingStrengthApiResponse =
    /** status 200 Success */ GetCoachingStrengthListListApiResponse;
export type GetCoachingCoachingStrengthApiArg = {
    employeeNumber?: string;
    authorEmployeeNumber?: string;
    month?: number;
    year?: number;
};
export type PutCoachingUpdateCoachingStrengthApiResponse = /** status 200 Success */ BooleanApiResponse;
export type PutCoachingUpdateCoachingStrengthApiArg = {
    updateCoachingStrength: UpdateCoachingStrength;
};
export type BooleanApiResponse = {
    statusCode?: number;
    message?: string | null;
    data?: boolean;
    status?: boolean;
};
export type CreateCoachingStrength = {
    employeeNumber?: string | null;
    authorEmployeeNumber?: string | null;
    strengthDescription?: string | null;
    strengthTitle?: string | null;
    coreValueId?: number | null;
    month?: number | null;
    year?: number | null;
};
export type ReplyCoachingStrength = {
    coachingStrengthId?: number;
    responseEmployeeNumber?: string | null;
    responseDescription?: string | null;
};
export type GetCoachingStrengthList = {
    coaching_strength_id?: number;
    employee_number?: string | null;
    employee_name?: string | null;
    author_employee_number?: string | null;
    author_employee_name?: string | null;
    scorecard_role_id?: number;
    strength_date?: string;
    strength_title?: string | null;
    strength_description?: string | null;
    core_value_id?: number;
    core_value_abbreviation?: string | null;
    response_employee_number?: string | null;
    response_employee_name?: string | null;
    response_date?: string | null;
    response_description?: string | null;
};
export type GetCoachingStrengthListListApiResponse = {
    statusCode?: number;
    message?: string | null;
    data?: GetCoachingStrengthList[] | null;
    status?: boolean;
};
export type UpdateCoachingStrength = {
    coachingStrengthId?: number;
    coreValueId?: number;
    strengthTitle?: string | null;
    strengthDescription?: string | null;
    month?: number | null;
    year?: number | null;
    // coachingBehaviorId?: number | null;
    // coachingSkillId?: number | null;

};
export const {
    usePostCoachingCreateCoachingStrengthMutation,
    usePutCoachingReplyCoachingStrengthMutation,
    useGetCoachingCoachingStrengthQuery,
    usePutCoachingUpdateCoachingStrengthMutation,
} = injectedRtkApi;
